import React from "react";
import { LongTextLabel } from "@sscs/ui";
import { COMMUNITY_TYPE_TO_TEXT } from "../../../../constants";
import { PREVALENCE_TO_TEXT } from "../../../utils";
import { sortCommunitiesByPrevalence } from "../utils";
import styles from "./prevalenceSummary.module.scss";
const PrevalenceSummary = ({ prevalence, }) => {
    const prevalenceByCommunity = sortCommunitiesByPrevalence(prevalence)
        .map((community) => {
        var _a;
        return `${(_a = prevalence[community]) === null || _a === void 0 ? void 0 : _a.map((item) => PREVALENCE_TO_TEXT[item].toLowerCase()).join(", ")} in ${COMMUNITY_TYPE_TO_TEXT[community]}`;
    })
        .join("; ");
    return (React.createElement("div", { className: styles["prevalence-by-community"] },
        "Prevalence:",
        React.createElement(LongTextLabel, { label: prevalenceByCommunity ? prevalenceByCommunity : "--" })));
};
export default PrevalenceSummary;
//# sourceMappingURL=PrevalenceSummary.js.map